module.exports = __webpack_public_path__ + "static/media/recommend-program-bg.ca4e5b67.png";